var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcn24X24SelectedAssetManagement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.25 9H5.25C4.0095 9 3 7.9905 3 6.75V5.25C3 4.0095 4.0095 3 5.25 3H9.25C10.4905 3 11.5 4.0095 11.5 5.25V6.75C11.5 7.9905 10.4905 9 9.25 9ZM9.25 21H5.25C4.0095 21 3 19.9905 3 18.75V12.25C3 11.0095 4.0095 10 5.25 10H9.25C10.4905 10 11.5 11.0095 11.5 12.25V18.75C11.5 19.9905 10.4905 21 9.25 21ZM18.75 21H14.75C13.5095 21 12.5 19.9905 12.5 18.75V17.25C12.5 16.0095 13.5095 15 14.75 15H18.75C19.9905 15 21 16.0095 21 17.25V18.75C21 19.9905 19.9905 21 18.75 21ZM18.75 14H14.75C13.5095 14 12.5 12.9905 12.5 11.75V5.25C12.5 4.0095 13.5095 3 14.75 3H18.75C19.9905 3 21 4.0095 21 5.25V11.75C21 12.9905 19.9905 14 18.75 14Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcn24X24SelectedAssetManagement);
export default __webpack_public_path__ + "static/media/icn_24x24_selected_asset_management.e2798da500ecf84b7e3b1ce14faa3aca.svg";
export { ForwardRef as ReactComponent };